/* XTR • XO.SKLTN product page — shared behaviour.
   - reveal-on-scroll for .po-reveal and blueprint draw-on for .po-bp-figure
   - count-up for .po-num[data-to]
   - Mid/Full blueprint height toggle
   Progressive enhancement: if JS is off or reduced-motion is preferred, all
   content stays fully visible (see .xtrpo-js gate in xtr-po.css). */
(function(){
  if(window.__xtrPoInit) return; window.__xtrPoInit = 1;
  var reduce = false;
  try { reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
  var root = document.documentElement;

  function fmt(n, dec){
    var s = (dec>0) ? n.toFixed(dec) : String(Math.round(n));
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function countUp(el){
    if(el.dataset.done) return; el.dataset.done = '1';
    var to = parseFloat(el.getAttribute('data-to'));
    if(isNaN(to)){ return; }
    var dec = parseInt(el.getAttribute('data-dec')||'0', 10);
    var pre = el.getAttribute('data-pre')||'';
    var dur = 1300, start = null;
    function set(v){ el.firstChild ? (el.childNodes[0].nodeValue = pre+fmt(v,dec)) : (el.textContent = pre+fmt(v,dec)); }
    function step(ts){
      if(start===null) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      var e = 1 - Math.pow(1-p, 3);
      set(to*e);
      if(p<1) requestAnimationFrame(step); else set(to);
    }
    // guaranteed final value even if rAF is throttled (e.g. background tab)
    setTimeout(function(){ if(el.dataset.done==='1'){ set(to); } }, dur+400);
    requestAnimationFrame(step);
  }

  function activate(el){
    el.classList.add('in');
    var nums = el.querySelectorAll('.po-num[data-to]');
    for(var i=0;i<nums.length;i++) countUp(nums[i]);
  }

  function initToggles(scope){
    var toggles = (scope||document).querySelectorAll('.po-bp-toggle');
    for(var t=0;t<toggles.length;t++){
      (function(tg){
        var fig = tg.closest('.po-bp-side') ? tg.closest('.po-bp-wrap').querySelector('.po-bp-figure') : document.querySelector('.po-bp-figure');
        var dimsRoot = tg.closest('.po-bp-side') ? tg.closest('.po-bp-side') : document;
        var btns = tg.querySelectorAll('button[data-h]');
        for(var b=0;b<btns.length;b++){
          btns[b].addEventListener('click', function(){
            var h = this.getAttribute('data-h');
            for(var k=0;k<btns.length;k++) btns[k].setAttribute('aria-pressed', btns[k]===this ? 'true':'false');
            if(fig) fig.setAttribute('data-h', h);
            var rows = dimsRoot.querySelectorAll('.po-bp-dims li[data-mid][data-full]');
            for(var r=0;r<rows.length;r++){
              var v = rows[r].querySelector('.v');
              if(v) v.textContent = rows[r].getAttribute('data-'+h);
            }
          });
        }
      })(toggles[t]);
    }
  }

  function boot(){
    initToggles(document);
    var targets = [].slice.call(document.querySelectorAll('.po-reveal, .po-bp-figure'));
    if(reduce || !('IntersectionObserver' in window)){
      targets.forEach(activate); return;
    }
    root.classList.add('xtrpo-js');
    // don't flash out anything already in view on load
    var vh = window.innerHeight || document.documentElement.clientHeight;
    targets.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < vh*0.92 && r.bottom > 0) activate(el);
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ activate(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function(el){ if(!el.classList.contains('in')) io.observe(el); });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
